<script lang="jsx">
/* eslint-disable react/react-in-jsx-scope */
import { mapModifiers } from '@/libs/component';
import ACheckbox from '@/components/atoms/checkbox';
import { h } from 'vue';

export default {
  name: 'a-data-table-body',
  components: {
    ACheckbox,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    columns: {
      type: Array,
      default: new Array(0),
    },
    data: {
      type: Array,
      default: new Array(0),
    },
    table: {
      type: Object,
      required: true,
    },
    isHistoryListTable: {
      type: Boolean,
      default: false,
    },
    isOutboundList: {
      type: Boolean,
      default: false,
    },
    isSendchoiceList: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['rowClick'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-data-table-body');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    getCellClass(rowIndex, columnIndex, row, column) {
      const classes = [column.id, `a-data-table-column--${column.type}`, column.align, column.nowrap, column.class];

      const cellClassName = this.table.cellClassName;
      if (typeof cellClassName === 'string') {
        classes.push(cellClassName);
      } else if (typeof cellClassName === 'function') {
        classes.push(
          cellClassName.call(null, {
            rowIndex,
            columnIndex,
            row,
            column,
          })
        );
      }

      return classes.join(' ');
    },
    rowClick(row, e) {
      if (this.isHistoryListTable) {
        this.$emit('rowClick', { row: row });
      }
    },
  },
  render() {
    const self = this;
    return (
      <table className={this.componentClassName}>
        <colgroup>
          {this.columns.map(column => {
            return <col name={column.id} key={column.id} />;
          })}
        </colgroup>
        <tbody>
          {this.data.map((row, index) => [
            <tr
              id={'table-row-' + index}
              className={this.isOutboundList && row.isGrey ? 'a-data-table-body__striped-row' : ''}
              key={index}
              onClick={e => this.rowClick(row, e)}
            >
              {this.columns.map((column, cellIndex) => {
                return (
                  <td
                    className={this.getCellClass(index, cellIndex, row, column)}
                    key={cellIndex}
                    id={'row-' + index + '-col-' + cellIndex}
                  >
                    {column.renderCell.call(this, {
                      row,
                      column,
                      index,
                      isOutboundList: this.isOutboundList,
                      isSendchoiceList: this.isSendchoiceList,
                    })}
                  </td>
                );
              })}
            </tr>,
          ])}
        </tbody>
      </table>
    );
  },
};
</script>
